exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".customizeCardButton___3UlOO {\n  width: 280px;\n}\n.existingDraftsForCardSuiteModal___2bSaa {\n  width: 552px;\n  height: 479px;\n}\n@media (max-width: 767px) {\n  .existingDraftsForCardSuiteModal___2bSaa {\n    width: initial;\n    height: initial;\n  }\n}\n", ""]);

// exports
exports.locals = {
	"customizeCardButton": "customizeCardButton___3UlOO",
	"existingDraftsForCardSuiteModal": "existingDraftsForCardSuiteModal___2bSaa"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"modules":true,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/less-loader/dist/cjs.js!./src/cards/components/ProductDetail/CustomizeCardButton/styles.module.less
// module id = 1799
// module chunks = 70